/** Canonical brand strings for the web app. Callers import these so copy cannot drift. */

export const PRODUCT_NAME = 'TEOAI';
export const COMPANY_NAME = 'TEO';
/** The first line of the tagline only. Email carries the full two-line tagline. */
export const BRAND_TAGLINE_SHORT = 'The Future of Property Management';

export const DEFAULT_PAGE_TITLE = `${PRODUCT_NAME} | ${BRAND_TAGLINE_SHORT}`;

export function pageTitle(page: string): string {
  return `${page} | ${PRODUCT_NAME}`;
}
